/**
 * The förhandlingsframställan as a composition — i.e. as data.
 *
 * Sections are numbered automatically (§), so "Grund för yrkandet" closes up
 * when it is omitted. The hyreslista appendix follows the signature on a new
 * page. Only the landlord signs; the tenant organisation is the recipient
 * (`signs: false`) and the document is delivered, not e-signed.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Förhandlingsframställning enligt hyresförhandlingslagen (1978:304)';
const FORM_NUMBER = 'Formulär R-20';
export const forhandlingsframstallningV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'forhandlingsframstallning',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Bostadshyressättningsavtal',
        numberStyle: 'paragraph',
        shortTitle: 'Förhandlingsframställning',
        formNumber: FORM_NUMBER,
        statute: 'hyresförhandlingslagen (1978:304)',
        signingMode: 'manual_delivery',
        preamble: 'Hyresvärdens framställning om förhandling till hyresgästorganisationen enligt hyresförhandlingslagen (1978:304).',
        description: 'Hyresvärdens framställning om förhandling enligt hyresförhandlingslagen (1978:304), ställd till en hyresgästorganisation (t.ex. Hyresgästföreningen).\n\n' +
            'Används för att begära förhandling om t.ex. årlig hyreshöjning, ändrade hyror eller andra hyresvillkor, första hyra efter ombyggnad eller vid nybyggnation. Innehåller yrkande, grund, underlag och kallelse till första förhandlingssammanträde (15 § hyresförhandlingslagen).\n\n' +
            'Vem undertecknar: hyresvärden. Motparten (hyresgästorganisationen) är mottagare. Skrivs ut/signeras och skickas till organisationen.\n\n' +
            'Bilagor (fastighetsbeskrivning, lägenhetsförteckning, hyreslista m.m.) läggs till under fliken Bilagor — valfritt antal.',
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
            {
                id: 'tenant_org',
                label: 'Hyresgästorganisation',
                role: 'other',
                ordinal: 0,
                required: true,
                signs: false,
                kind: 'organisation',
                help: 'Den hyresgästorganisation framställningen ställs till. Om din ' +
                    'förhandlingspart är Hyresgästföreningen (802498-6465) ska ' +
                    'framställan istället skickas till det regionkontor som förhandlar ' +
                    'fastigheten.',
            },
        ],
        propertySlots: [
            {
                id: 'fastigheter',
                label: 'Fastigheter',
                multi: true,
                required: true,
                help: 'Lägg till alla fastigheter som framställningen avser.',
            },
        ],
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'mottagare', blockRef: 'framstallan.mottagare@v1', input: {} },
        { instanceId: 'begaran', blockRef: 'framstallan.begaran@v1', input: {} },
        { instanceId: 'forhandlingen-avser', blockRef: 'framstallan.forhandlingen-avser@v1', input: {} },
        { instanceId: 'yrkande', blockRef: 'framstallan.yrkande@v1', input: {} },
        { instanceId: 'grund', blockRef: 'framstallan.grund@v1', input: {} },
        { instanceId: 'underlag', blockRef: 'framstallan.underlag@v1', input: {} },
        { instanceId: 'sammantrade', blockRef: 'framstallan.sammantrade@v1', input: {} },
        { instanceId: 'kontaktperson', blockRef: 'framstallan.kontaktperson@v1', input: {} },
        // The section's own '§ Underskrift' heading is the only one; drop the panel caption.
        { instanceId: 'underskrift', blockRef: 'framstallan.underskrift@v1', input: { heading: false } },
        { instanceId: 'hyreslista', blockRef: 'framstallan.hyreslista@v1', input: {} },
    ],
});
//# sourceMappingURL=forhandlingsframstallning.js.map